import { render, staticRenderFns } from "./ShotFile.vue?vue&type=template&id=4c7579cf&scoped=true&"
import script from "./ShotFile.vue?vue&type=script&lang=js&"
export * from "./ShotFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7579cf",
  null
  
)

export default component.exports